import _IndustryDetail from "./IndustryDetail"
import _logic from "./logic"

export const IndustryDetail = _IndustryDetail
export const logic = _logic

export default {
  IndustryDetail,
  logic,
}
